module.exports = __webpack_public_path__ + "img/main.2f232ed2.jpg";